<template>
	<div id="app" :class="[menu ? 'twoColumns' : 'oneColumn']">
		<div id="nav" v-if="menu">
			<div class="menu-icons">
				<router-link to="/dashboard">
					<div class="menu-divider">
						<div>
							<ion-icon name="cube"></ion-icon>
						</div>
						<div>Dashboard</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/heartbeat">
					<div class="menu-divider">
						<div>
							<ion-icon name="heart"></ion-icon>
						</div>
						<div>Heartbeat</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/sync-changes">
					<div class="menu-divider">
						<div>
							<ion-icon name="sync-circle"></ion-icon>
						</div>
						<div>Sync Changes</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/top-sales">
					<div class="menu-divider">
						<div>
							<ion-icon name="bar-chart"></ion-icon>
						</div>
						<div>Top Sales</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/orders">
					<div class="menu-divider">
						<div>
							<ion-icon name="download"></ion-icon>
						</div>

						<div>Export Orders</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="easel"></ion-icon>
						</div>

						<div>Order Report</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-promotions">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Promotions</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/members">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Members</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/member-rewards">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Export Member Rewards</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/search/promotions">
					<div class="menu-divider">
						<div>
							<ion-icon name="pricetags"></ion-icon>
						</div>

						<div>Search Promotions</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/check-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="checkmark-done-circle"></ion-icon>
						</div>
						<div>Check Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/mismatch-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="checkmark-done-circle"></ion-icon>
						</div>
						<div>Export Product Mismatch</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/shop-product-check">
					<div class="menu-divider">
						<div>
							<ion-icon name="shield-checkmark"></ion-icon>
						</div>
						<div>Shop Products Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="cloud-download"></ion-icon>
						</div>
						<div>Export Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-item-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="download"></ion-icon>
						</div>

						<div>Order Item Reports</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/brand-price-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-working"></ion-icon>
						</div>
						<div>Brand Price Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/product-price-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-working"></ion-icon>
						</div>
						<div>Product Price Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/stock-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="options"></ion-icon>
						</div>
						<div>Stock Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/stock/sync-check">
					<div class="menu-divider">
						<div>
							<ion-icon name="options"></ion-icon>
						</div>
						<div>Stock Sync Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/import-shop-products">
					<div class="menu-divider">
						<div>
							<ion-icon name="code-download"></ion-icon>
						</div>
						<div>Import Shop Products</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/import-chemicals">
					<div class="menu-divider">
						<div>
							<ion-icon name="checkmark-done-circle"></ion-icon>
						</div>
						<div>Import Chemicals</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-popi">
					<div class="menu-divider">
						<div>
							<ion-icon name="barcode"></ion-icon>
						</div>
						<div>Export PO/PI</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-po-pdf">
					<div class="menu-divider">
						<div>
							<ion-icon name="folder"></ion-icon>
						</div>
						<div>Export PO PDF</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-return">
					<div class="menu-divider">
						<div>
							<ion-icon name="backspace"></ion-icon>
						</div>
						<div>Export Return</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/stock-adjustment">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Export Stock Adjustment</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-transfers">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Export Transfers</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/warehouse-product-add">
					<div class="menu-divider">
						<div>
							<ion-icon name="repeat"></ion-icon>
						</div>
						<div>Add Warehouse Product</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-dp">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Direct Purchase</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/ledger">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Ledger</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/order-items/detail-report">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Items Detail Report</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export/product-transfer">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Product Transfer</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/autoid/check">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Auto ID Check</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/delete/orders">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Delete Orders</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/delete/products">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Delete Products / Brands</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/export-stock-total">
					<div class="menu-divider">
						<div>
							<ion-icon name="resize"></ion-icon>
						</div>
						<div>Export Stock Total</div>
					</div>
				</router-link>
			</div>

			<div class="menu-icons">
				<router-link to="/logout">
					<div class="menu-divider">
						<div>
							<ion-icon name="log-out"></ion-icon>
						</div>
						<div>Logout</div>
					</div>
				</router-link>
			</div>

			<div>
				{{ this.$config.serverUrl }}
			</div>
		</div>

		<div class="main-content">
			<div class="menu-display-icon">
				<div @click="toggleMenu()" class="sub-menu-display-icon"><ion-icon name="apps-outline"></ion-icon></div>
			</div>
			<router-view />
		</div>
	</div>
</template>

<script>
export default {
	name: 'App',
	data: function() {
		return {
			menu: true,
			test: null
		}
	},
	watch: {
		'$store.state.route.query': {
			immidiate: true,
			handler: function(newVal) {
				this.test = newVal

				if (newVal.menu == 'false') {
					this.menu = false
					this.$store.dispatch('set_menu', false)
				} else if (newVal.menu == 'true') {
					this.menu = true
					this.$store.dispatch('set_menu', true)
				}

				if (newVal.token !== undefined && newVal.token !== '') {
					this.$axios.defaults.headers.common['Authorization'] = 'Token ' + newVal.token

					this.$store.dispatch('set_auth', newVal.token)
				} else if (this.$store.state.auth) {
					// Set auth if exist
					this.$axios.defaults.headers.common['Authorization'] = 'Token ' + this.$store.state.auth
				}
			}
		}
	},
	mounted: async function() {
		if (this.$store.state.menu === true) {
			this.menu = true
		} else {
			this.menu = false
		}
	},
	methods: {
		// Hide or display menu
		toggleMenu: function() {
			if (this.$store.state.menu === true) {
				this.menu = false
				this.$store.dispatch('set_menu', false)
			} else {
				this.menu = true
				this.$store.dispatch('set_menu', true)
			}
		}
	}
}
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/2.5.94/css/materialdesignicons.min.css');

@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');

body {
	margin: 0;
	background-color: #f6f9fd;
}

#app {
	font-family: 'Poppins', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #1c2d40;
	width: 100%;
	height: 100vh;
	font-size: 14px;
}

.menu-display-icon {
	text-align: left;
}

.sub-menu-display-icon {
	width: 30px;
	color: #eee;
}

.main-content {
	background-color: #f6f9fd;
}

.twoColumns {
	display: grid;
	grid-template-columns: 200px 1fr;
}

.oneColumn {
	display: grid;
	grid-template-columns: 1fr;
}

#nav {
	background-color: #000;
	color: #ccc;
	text-align: left;
	padding: 0 10px;
	font-size: 12px;
}

#nav .menu-icons {
	margin-top: 15px;
}

#nav .menu-divider {
	display: grid;
	grid-template-columns: 25px 1fr;
	grid-gap: 5px;
}

#nav a {
	color: #ccc;
}

.button-wrapper {
	width: 250px;
	margin: 20px auto;
}

.big-button {
	padding: 20px 20px;
	background-color: #ff4343;
	color: #fff;
	font-weight: 500;
	border: none;
	font-size: 14px;
	border-radius: 10px;
	cursor: pointer;
	outline: 0;
}

body h1 {
	margin: 20px 0;
	font-size: 24px;
	font-weight: 500;
	text-align: center;
}

#app input {
	-webkit-box-shadow: 0px 0px 5px 0px rgb(201, 238, 250);
	-moz-box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	box-shadow: 0px 0px 5px 0px rgba(201, 238, 250, 1);
	border: 1px solid #d5e3f5;
	background-color: #fff;
	font-size: 13px;
	height: 40px;
}

.paginationWrapper {
	margin: auto;
}

.pagination {
	height: 70px;
	width: 400px;
	margin: auto;
	padding: 5px 20px;
	font-weight: bold;
}

.pagination a {
	color: #999;
	padding: 6px 12px;
	line-height: 1.42;
}

.pagination .active a {
	color: #999;
	padding: 0;
	outline: 0;
}

.pagination li.active {
	padding: 10px;
	border-radius: 20px;
	background-color: #810369;
	height: 40px;
	width: 40px;
}

.pagination li.active a {
	color: #fff;
	font-weight: bolder;
}

#app #nav ion-icon {
	font-size: 21px;
	color: #999;
}
</style>
